<template>
	<!-- <div class="searchWrap"> -->
	<div class="searchPage">
		<!-- <div class="searchPage__inside"> -->
		<div class="searchPage__topCont gutter">
			<div class="searchPage__top darkText">
				<h1>Search</h1>
				<input
					v-on:keyup.enter="search"
					class="searchPage__input"
					v-model="searchInput"
					placeholder="Type to search"
				/>

				<SearchIcon v-if="windowWidth > 980" @search="search"></SearchIcon>
				<SearchIconSmall v-else @search="search"></SearchIconSmall>
				<CloseSearch
					v-if="windowWidth > 980"
					@clearSearch="clearSearch"
				></CloseSearch>
				<CloseSearchSmall v-else @clearSearch="clearSearch"></CloseSearchSmall>
			</div>
		</div>
		<div class="searchPage__bottomCont">
			<div v-if="noResults" class="searchPage__noResults">
				<p>there are no results for "{{ notFoundText }}"</p>
			</div>
			<div class="searchPage__bottom">
				<div v-if="loading" class="searchPage__loading">
					<div class="searchPage__loadingContainer">
						<div class="loading-wrapper loading-wrapper--search">
							<div class="loader loader-7"></div>
						</div>
					</div>
				</div>
				<p v-if="total > 0 && total < 2" class="searchPage__total">
					{{ total }} result
				</p>
				<p v-else-if="total > 1 && total != 0" class="searchPage__total">
					{{ total }} results
				</p>
				<div class="searchPage__grid">
					<div v-if="total > 0" class="searchPage__left">
						<p class="searchPage__p">Filter your search by:</p>
						<ul v-if="total > 0" class="searchPage__filtersUl">
							<li
								v-for="(fill, index) in filters"
								:key="index"
								:class="[
									fill == selectedFilter
										? 'filterPage__filter filterPage__filter--open filterPage__filter--noMinwidth'
										: 'filterPage__filter  filterPage__filter--noMinwidth',
								]"
								@click="selectFilter(fill)"
								v-if="searchResults[fill].length > 0"
							>
								<p>
									{{ filterNames[index] }} ({{ searchResults[fill].length }})
								</p>
							</li>
						</ul>
					</div>
					<div class="searchPage__right">
						<ul class="searchPage__resultsUl">
							<li
								v-for="(item, index) in displayedResults"
								:key="index"
								class="searchPage__resultsLi"
							>
								<a :href="item.url"
									><div
										:class="[
											index === 0
												? 'searchPage__resultCont searchPage__resultCont--first'
												: 'searchPage__resultCont',
										]"
									>
										<div v-if="item.img" class="searchPage__imgCont">
											<img
												:src="item.img"
												:alt="item.title"
												class="searchPage__img"
											/>
										</div>
										<div class="searchPage__resText">
											<p class="searchPage__section">
												{{
													item.section.replace(
														/([A-Z]+)*([A-Z][a-z])/g,
														'$1 $2'
													)
												}}
											</p>
											<h4 class="searchPage__title">{{ item.title }}</h4>
											<p v-if="item.desc" class="searchPage__desc">
												{{ item.desc }}
											</p>
										</div>
									</div>
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
	<!-- </div> -->
</template>

<script>
import SearchIcon from './svg/SearchIcon';
import SearchIconSmall from './svg/SearchIconSmall';

import CloseSearch from './svg/CloseSearch';
import CloseSearchSmall from './svg/CloseSearchSmall';

import axios from 'axios';
export default {
	name: 'Searchpage',
	components: {
		SearchIcon,
		CloseSearch,
		SearchIconSmall,
		CloseSearchSmall,
	},
	data() {
		return {
			windowWidth: null,
			searchInput: null,
			searchData: null,
			searchResults: {
				allResults: null,
				other: null,
				collections: null,
				exhibitions: null,
				pemcast: null,
				blog: null,
				historicHouses: null,
				events: null,
				pressNews: null,
			},
			filters: [
				'allResults',
				'blog',
				'collections',
				'historicHouses',
				'pemcast',
				'pressNews',
				'events',
				'exhibitions',
				'other',
			],
			filterNames: [
				'All Results',
				'Blog',
				'Collections',
				'Historic Houses',
				'Pemcast',
				'Press & News',
				'Events',
				'Exhibitions',
				'Other',
			],
			displayedResults: [],
			selectedFilter: null,
			total: 0,
			loading: false,
			noResults: false,
			notFoundText: '',
		};
	},
	beforeMount() {
		this.getUrl();
	},
	mounted() {
		this.window();
		let that = this;
		jQuery(document).ready(function ($) {
			$(window).resize(function () {
				that.window();
			});
		});
	},
	watch: {
		searchInput(term) {
			// this.updateUrl();
			// if (term === null || term.length === 0) {
			//   this.displayedResults = [];
			//   this.selectedFilter = null;
			//   this.total = 0;
			//   return;
			// }
			// this.search();
		},
		searchData(val) {
			if (val === null) {
				return;
			}
			this.searchSort(val);
		},
		selectedFilter(fill) {
			this.displayedResults = this.searchResults[fill];
		},
		total(num) {
			if (num > 0) {
				this.displayedResults = this.searchResults.allResults;
				this.loading = false;
			} else if (num > 0 && this.searchInput.length > 0) {
				this.displayedResults = [];
				this.loading = false;
				this.noResults = true;
			}
		},
	},
	methods: {
		window() {
			this.windowWidth = $(window).width();
		},
		getUrl() {
			let params = new URLSearchParams(document.location.search);
			this.searchInput = params.get('q');
			if (params.get('q').length > 0) {
				this.search();
			}
		},
		updateUrl() {
			let url = new URLSearchParams(document.location.search);
			let params = new URLSearchParams(url.search);
			params.set('q', this.searchInput);
			let newPath = window.location.origin + '/search?' + params.toString();
			history.pushState(null, '', newPath);
		},
		search() {
			this.updateUrl();
			this.loading = true;
			this.searchFunction();
		},
		async searchFunction() {
			let search = this.searchInput.replaceAll(' ', ' OR ');
			try {
				const { data: dataObj } = await axios.get('/api/v1/searchpage', {
					params: {
						searchTerm: search,
					},
				});
				this.searchData = dataObj;
			} catch (error) {
				console.error(error);
				console.log('error');
			}
		},
		searchSort(val) {
			let filteredArray = val.data.filter((obj) => obj.url !== null);
			if (filteredArray.length == 0) {
				this.noResults = true;
				this.displayedResults = [];
				this.total = 0;
				this.notFoundText = this.searchInput;
				this.loading = false;
				return;
			}
			this.noResults = false;
			this.searchResults.allResults = filteredArray;
			this.searchResults.pressNews = filteredArray.filter(
				(obj) => obj.section === 'pressNews'
			);
			this.searchResults.blog = filteredArray.filter(
				(obj) => obj.section === 'blog'
			);
			this.searchResults.pemcast = filteredArray.filter(
				(obj) => obj.section === 'pemcast'
			);
			this.searchResults.collections = filteredArray.filter(
				(obj) => obj.section === 'collections'
			);
			this.searchResults.historicHouses = filteredArray.filter(
				(obj) => obj.section === 'historicHouses'
			);
			this.searchResults.events = filteredArray.filter(
				(obj) => obj.section === 'events'
			);
			this.searchResults.exhibitions = filteredArray.filter(
				(obj) => obj.section === 'exhibitions'
			);
			this.searchResults.other = filteredArray.filter(
				(obj) =>
					obj.section !== 'pemcast' &&
					obj.section !== 'exhibitions' &&
					obj.section !== 'events' &&
					obj.section !== 'blog' &&
					obj.section !== 'collections' &&
					obj.section !== 'pressNews' &&
					obj.section !== 'historicHouses'
			);
			this.total = filteredArray.length;
			this.selectedFilter = 'allResults';
		},
		selectFilter(fill) {
			this.selectedFilter = fill;
		},
		clearSearch() {
			this.searchInput = '';
			this.total = null;
			this.noResults = false;
			this.displayedResults = [];
			this.searchResults.allResults = [];
			this.searchResults.other = [];
			this.searchResults.collections = [];
			this.searchResults.exhibitions = [];
			this.searchResults.pemcast = [];
			this.searchResults.blog = [];
			this.searchResults.historicHouses = [];
			this.searchResults.events = [];
			this.searchResults.pressNews = [];
		},
	},
};
</script>
